import { render, staticRenderFns } from "./ThemeChangeTemplateDialog.vue?vue&type=template&id=6d91ffe0"
import script from "./ThemeChangeTemplateDialog.vue?vue&type=script&lang=js"
export * from "./ThemeChangeTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7sjryms56nihpddmmbru7sns3m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports